class BeforeAfter extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.before-after-slider');
    this.foregroundImage = this.querySelector('.before-after-image--foreground');
    this.handle = this.querySelector('.before-after-handle');
    this.handleIcon = this.querySelector('.before-after-handle__icon');
    this.container = this.querySelector('.before-after-container');
    this.layout = this.dataset.layout || 'horizontal';
    this.isVertical = this.layout === 'vertical';
    this.isInverted = this.classList.contains('invert-layout');
    this.isDragging = false;
    
    this.init();
  }

  init() {
    if (!this.slider || !this.foregroundImage || !this.handle || !this.container) return;

    // スライダーの入力イベント
    this.slider.addEventListener('input', this.handleSliderInput.bind(this));
    
    // コンテナ全体でのドラッグ開始
    this.container.addEventListener('mousedown', this.handleDragStart.bind(this));
    this.container.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
    
    // 初期値を設定
    this.updatePosition(50);
  }

  handleSliderInput(e) {
    var value = parseFloat(e.target.value);
    this.updatePosition(value);
  }

  handleDragStart(e) {
    this.isDragging = true;
    if (this.handleIcon) {
      this.handleIcon.classList.add('is-dragging');
    }
    
    // 最初の位置を設定
    this.handleDrag(e);
    
    // マウス移動イベント
    var handleMove = this.handleDrag.bind(this);
    var handleEnd = this.handleDragEnd.bind(this);
    
    document.addEventListener('mousemove', handleMove);
    document.addEventListener('mouseup', handleEnd);
    
    // クリーンアップ用にイベントリスナーを保存
    this._handleMove = handleMove;
    this._handleEnd = handleEnd;
  }

  handleTouchStart(e) {
    this.isDragging = true;
    if (this.handleIcon) {
      this.handleIcon.classList.add('is-dragging');
    }
    
    // 最初の位置を設定
    this.handleTouchDrag(e);
    
    // タッチ移動イベント
    var handleMove = this.handleTouchDrag.bind(this);
    var handleEnd = this.handleDragEnd.bind(this);
    
    document.addEventListener('touchmove', handleMove, { passive: false });
    document.addEventListener('touchend', handleEnd);
    document.addEventListener('touchcancel', handleEnd);
    
    // クリーンアップ用にイベントリスナーを保存
    this._handleMove = handleMove;
    this._handleEnd = handleEnd;
  }

  handleDrag(e) {
    if (!this.isDragging) return;
    
    if (e.cancelable) {
      e.preventDefault();
    }
    
    var rect = this.container.getBoundingClientRect();
    var value;
    
    if (this.isVertical) {
      var y = e.clientY - rect.top;
      value = (y / rect.height) * 100;
    } else {
      var x = e.clientX - rect.left;
      value = (x / rect.width) * 100;
    }
    
    // 範囲を0-100に制限
    value = Math.max(0, Math.min(100, value));
    
    // スライダーの値を更新
    this.slider.value = value;
    this.updatePosition(value);
  }

  handleTouchDrag(e) {
    if (!this.isDragging) return;
    
    if (e.cancelable) {
      e.preventDefault();
    }
    
    if (!e.touches || e.touches.length === 0) return;
    
    var rect = this.container.getBoundingClientRect();
    var value;
    
    if (this.isVertical) {
      var y = e.touches[0].clientY - rect.top;
      value = (y / rect.height) * 100;
    } else {
      var x = e.touches[0].clientX - rect.left;
      value = (x / rect.width) * 100;
    }
    
    // 範囲を0-100に制限
    value = Math.max(0, Math.min(100, value));
    
    // スライダーの値を更新
    this.slider.value = value;
    this.updatePosition(value);
  }

  handleDragEnd() {
    this.isDragging = false;
    if (this.handleIcon) {
      this.handleIcon.classList.remove('is-dragging');
    }
    
    // イベントリスナーを削除
    if (this._handleMove && this._handleEnd) {
      document.removeEventListener('mousemove', this._handleMove);
      document.removeEventListener('touchmove', this._handleMove);
      document.removeEventListener('mouseup', this._handleEnd);
      document.removeEventListener('touchend', this._handleEnd);
      document.removeEventListener('touchcancel', this._handleEnd);
      
      this._handleMove = null;
      this._handleEnd = null;
    }
  }

  updatePosition(value) {
    // スライダーの位置に応じて画像を表示（左にスライド = 左側の画像を表示）
    var clipValue = 100 - value;
    
    if (this.isVertical) {
      // 縦方向レイアウト
      if (this.isInverted) {
        this.foregroundImage.style.clipPath = 'inset(' + value + '% 0 0 0)';
      } else {
        this.foregroundImage.style.clipPath = 'inset(0 0 ' + clipValue + '% 0)';
      }
      this.handle.style.top = value + '%';
      this.handle.style.left = '0';
      this.handle.style.transform = 'translateY(-50%)';
    } else {
      // 横方向レイアウト
      if (this.isInverted) {
        this.foregroundImage.style.clipPath = 'inset(0 0 0 ' + value + '%)';
      } else {
        this.foregroundImage.style.clipPath = 'inset(0 ' + clipValue + '% 0 0)';
      }
      this.handle.style.left = value + '%';
      this.handle.style.top = '0';
      this.handle.style.transform = 'translateX(-50%)';
    }
  }
}

// カスタム要素として登録
if (!customElements.get('before-after')) {
  customElements.define('before-after', BeforeAfter);
}